import { AnalyticsTranslationKeys } from 'intl/keys';
import { InspectionTranslationKeys } from 'intl/keys';
import type { TranslationKey } from 'intl/types/translationKey';
import type { ChartId } from './chartCatalog';

export type AnalyticsDashboardGroupKind = 'grid' | 'inspectionSummary';

export type AnalyticsDashboardGroup = Readonly<{
  id: string;
  labelId: TranslationKey;
  chartIds: readonly ChartId[];
  kind?: AnalyticsDashboardGroupKind;
}>;

export const ISSUES_DASHBOARD_GROUP: AnalyticsDashboardGroup = {
  id: 'issues',
  labelId: AnalyticsTranslationKeys.categoricalDistributionsSection,
  chartIds: [
    'originator',
    'rootCause',
    'impact',
    'environmentalAspect',
    'workType',
    'hsEffect',
    'hazardType',
  ],
};

export const INSPECTIONS_OVERVIEW_CHART_IDS = [
  'completedInspectionsByTemplate',
  'inspectionEvolution',
] as const satisfies readonly ChartId[];

export const ISSUES_SECTION_LABEL_ID = AnalyticsTranslationKeys.issuesSection;

export const INSPECTIONS_SECTION_LABEL_ID =
  AnalyticsTranslationKeys.inspectionsSection;

export const INSPECTIONS_SUMMARY_GROUP: AnalyticsDashboardGroup = {
  id: 'inspectionsSummary',
  labelId: InspectionTranslationKeys.summaryChart,
  chartIds: ['inspectionTriplet'],
  kind: 'inspectionSummary',
};

export type DashboardChartGridProps = Readonly<{
  xs: number;
  md: number;
  lg: number;
}>;

const DEFAULT_DASHBOARD_CHART_GRID: DashboardChartGridProps = {
  xs: 12,
  md: 6,
  lg: 4,
};

const DASHBOARD_CHART_GRID_OVERRIDES: Partial<
  Record<ChartId, Partial<DashboardChartGridProps>>
> = {
  inspectionEvolution: { md: 12, lg: 8 },
};

export function getDashboardChartGridProps(
  chartId: ChartId
): DashboardChartGridProps {
  return {
    ...DEFAULT_DASHBOARD_CHART_GRID,
    ...DASHBOARD_CHART_GRID_OVERRIDES[chartId],
  };
}
